function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".edita{fill:#797979;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2886.318 -680.616)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(2893.361 680.616)"
}, /*#__PURE__*/React.createElement("path", {
  className: "edita",
  d: "M2937.238,680.616a.617.617,0,0,0-.438.182l-6.168,6.168a.206.206,0,0,0,0,.291l1.733,1.733a.206.206,0,0,0,.291,0l6.168-6.168a.618.618,0,0,0,0-.874l-1.152-1.152a.615.615,0,0,0-.436-.181Z",
  transform: "translate(-2928.224 -680.616)"
}), /*#__PURE__*/React.createElement("path", {
  className: "edita",
  d: "M2920.951,715.664a.316.316,0,0,0-.278.177,26.324,26.324,0,0,0-1.108,2.564c-.141.374-.027.6.256.6a.83.83,0,0,0,.288-.06,26.375,26.375,0,0,0,2.564-1.108.29.29,0,0,0,.107-.452l-1.656-1.656a.242.242,0,0,0-.174-.07Z",
  transform: "translate(-2919.505 -708.227)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(2886.318 681.526)"
}, /*#__PURE__*/React.createElement("path", {
  className: "edita",
  d: "M2901.381,701.815h-13.208a1.857,1.857,0,0,1-1.856-1.855v-13.2a1.857,1.857,0,0,1,1.856-1.855h9.537a.637.637,0,1,1,0,1.273h-9.537a.583.583,0,0,0-.583.582v13.2a.583.583,0,0,0,.583.582h13.208a.583.583,0,0,0,.583-.582v-9.534a.636.636,0,1,1,1.273,0v9.534A1.857,1.857,0,0,1,2901.381,701.815Z",
  transform: "translate(-2886.318 -684.902)"
})));

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.825,
    height: 17.822,
    viewBox: "0 0 17.825 17.822",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit.79e2e603.svg";
export { ForwardRef as ReactComponent };